/**
 * PLOTLY-HOVER.UTILS
 * Style commun des bulles de survol des graphiques Plotly : même apparence que l'infobulle de l'application (fond sombre,
 * texte blanc, Open Sans) à la place du gris à cadre noir en Arial de Plotly. Les coins arrondis viennent d'une règle de
 * style (components.css, « .hovertext »), Plotly n'en propose pas.
 */
import type { Layout } from "plotly.js"

export const PLOTLY_HOVERLABEL: Partial<Layout["hoverlabel"]> = {
  bgcolor: "#1f2937",
  bordercolor: "#1f2937",
  font: { family: "'Open Sans', sans-serif", size: 14, color: "#ffffff" },
  align: "left",
  namelength: -1 //Le nom de la série en entier (Plotly le tronque à 15 caractères par défaut)
}

//Barres horizontales empilées : le nom de la population en gras, puis la série et sa valeur
export const PLOTLY_HOVERTEMPLATE_STACKED_BARS = "<b>%{y}</b><br>%{fullData.name} : %{x}<extra></extra>"
